var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 115,
    viewBox: "0 0 123 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.8008 49.3999H60.3008",
    stroke: "#A7A9B0",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 33.235C2 28.5551 2 26.2178 2.371 24.2674C3.16189 20.0796 5.19662 16.2273 8.20975 13.2132C11.2229 10.1991 15.0745 8.1632 19.2621 7.371C21.2178 7 23.5604 7 28.235 7C30.2808 7 31.309 7 32.2948 7.0901C36.5403 7.48882 40.567 9.15858 43.8488 11.8813C44.612 12.512 45.3328 13.2328 46.785 14.685L49.7 17.6C54.0248 21.9248 56.1872 24.0872 58.7736 25.5235C60.1952 26.3158 61.7032 26.9418 63.268 27.3891C66.1194 28.2 69.1775 28.2 75.2884 28.2H77.2706C91.2202 28.2 98.2003 28.2 102.732 32.281C103.151 32.652 103.548 33.0495 103.919 33.4682C108 37.9997 108 44.9798 108 58.9294V70.6C108 90.5863 108 100.582 101.788 106.788C95.5821 113 85.5863 113 65.6 113H44.4C24.4137 113 14.4179 113 8.2116 106.788C2 100.582 2 90.5863 2 70.6V33.235Z",
    stroke: "#62636C",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 20,
    r: 18,
    fill: "#F5F5F7",
    stroke: "#62636C",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.842 26.9765C112.09 27.2241 112.229 27.56 112.229 27.9102C112.229 28.2604 112.09 28.5962 111.842 28.8438C111.594 29.0915 111.259 29.2306 110.908 29.2306C110.558 29.2306 110.222 29.0915 109.975 28.8438L103 21.8677L96.0237 28.8416C95.7761 29.0893 95.4402 29.2284 95.09 29.2284C94.7398 29.2284 94.4039 29.0893 94.1563 28.8416C93.9087 28.594 93.7695 28.2582 93.7695 27.908C93.7695 27.5578 93.9087 27.2219 94.1563 26.9743L101.133 20.0004L94.1585 13.0242C93.9109 12.7766 93.7717 12.4407 93.7717 12.0905C93.7717 11.7404 93.9109 11.4045 94.1585 11.1569C94.4061 10.9093 94.742 10.7701 95.0922 10.7701C95.4424 10.7701 95.7783 10.9093 96.0259 11.1569L103 18.133L109.977 11.1558C110.224 10.9082 110.56 10.769 110.911 10.769C111.261 10.769 111.597 10.9082 111.844 11.1558C112.092 11.4034 112.231 11.7393 112.231 12.0894C112.231 12.4396 112.092 12.7755 111.844 13.0231L104.868 20.0004L111.842 26.9765Z",
    fill: "#62636C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.9e4489b0faa26201c38041d991393c51.svg";
export { ForwardRef as ReactComponent };